import Vue from 'vue'
import FuxunPaymentChoice from '@/components/FuxunPaymentChoice.vue'

export default () => new Promise(resolve => {
  const Choice = Vue.extend(FuxunPaymentChoice)
  const instance = new Choice()
  let finished = false
  const finish = method => {
    if (finished) return
    finished = true
    window.removeEventListener('popstate', cancel)
    instance.$destroy()
    if (instance.$el.parentNode) instance.$el.parentNode.removeChild(instance.$el)
    resolve(method)
  }
  const cancel = () => finish(null)
  instance.$on('select', finish)
  instance.$mount()
  document.body.appendChild(instance.$el)
  window.addEventListener('popstate', cancel)
})
